import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Avatar from 'flarum/common/components/Avatar';
import username from 'flarum/common/helpers/username';

// dayjs is Flarum's global instance (with relativeTime and locale plugins); importing the
// package would bundle a separate copy without them.

/** "Опубликовано 5 октября 2026 · 13:16" in the forum locale. */
export function publishedAt(date) {
  const locale = app.data.locale || 'ru';
  const day = new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }).format(date).replace(/\s?г\.$/, '');
  const time = new Intl.DateTimeFormat(locale, {
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
  return `${day} · ${time}`;
}

/**
 * Signature of the opening post, under its text and above "ОТВЕТЫ · N": avatar and name on the
 * left, publication date on the right (on its own line under the name when both don't fit).
 * Name and avatar link to the profile, as elsewhere in core.
 */
export default class OriginalPostAuthor extends Component {
  view() {
    const post = this.attrs.post;
    const user = post.user();
    const created = post.createdAt();
    const avatar = m(Avatar, {
      user: user || null
    });
    return m("div", {
      className: "TpAuthorRow"
    }, user ? m(Link, {
      className: "TpAuthorRow-avatar",
      href: app.route.user(user),
      "aria-hidden": "true",
      tabindex: "-1"
    }, avatar) : m("span", {
      className: "TpAuthorRow-avatar"
    }, avatar), m("div", {
      className: "TpAuthorRow-text"
    }, user ? m(Link, {
      className: "TpAuthorRow-name",
      href: app.route.user(user)
    }, username(user)) : m("span", {
      className: "TpAuthorRow-name"
    }, username(user)), m("span", {
      className: "TpAuthorRow-date"
    }, app.translator.trans('tarotportal-theme.forum.discussion.published'), ' ', m("time", {
      dateTime: dayjs(created).format(),
      title: dayjs(created).fromNow()
    }, publishedAt(created)))));
  }
}
flarum.reg.add('tarotportal-theme', 'forum/components/OriginalPostAuthor', OriginalPostAuthor);